var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-container",on:{"click":_vm.handlePlayVideo}},[_c('van-icon',{attrs:{"name":"video","color":"#666","size":"1.5em"}}),_c('div',{staticClass:"help-text"},[_vm._v("帮助")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }